import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { sortPartRequest } from "../../../actions/course-author/common";
import { PreviewInstructionComponent } from "./PreviewInstruction.component";
import { IPreviewInstructionDispatchProps, IPreviewInstructionStateProps } from "./types";
import { IState } from "ts/App/reducer";

const mapStateToProps = (state: IState): IPreviewInstructionStateProps => ({
  courseId: state.App.CourseAuthor._.courseId,
  isAuthor: state.App._.user?.isAuthor || false,
});

const mapDispatchToProps = (dispatch: Dispatch): IPreviewInstructionDispatchProps =>
  bindActionCreators({ sortPart: sortPartRequest }, dispatch);

export const PreviewInstruction = connect(mapStateToProps, mapDispatchToProps)(PreviewInstructionComponent);
